module.exports = __webpack_public_path__ + "img/c5.1e23410d.png";